import { createRoot } from 'react-dom/client';
import { envMockedApi } from '@repo/env';

import { MainApp } from './main-app';

const root = document.getElementById('root');
if (!root) throw Error('root element is undefined');

async function deferRender() {
  if (envMockedApi()) {
    const { worker } = await import('@repo/api/msw/browser.js');

    return worker.start({
      onUnhandledRequest: 'bypass',
    });
  }

  return;
}

deferRender().then(() => {
  createRoot(root).render(<MainApp />);
});
